import React, { PureComponent, ReactNode } from 'react';
import { GuestsIndicator } from 'js/components/GuestsIndicator';
import { PriceDisplay } from 'js/components/PriceDisplay/PriceDisplay';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { PricingDisplayType } from 'js/model/rainbow/venue/VenueMenuItemOutput';
import { ChannelOutput } from 'js/model/rainbow/content/ChannelOutput';
import { PriceRangeOutput } from 'js/model/rainbow/PriceRangeOutput';
import { Text, Stack, Inline } from '@treatwell/ui';
import { cmsBrowsePageToServicePriceRangeCms } from 'js/helpers/price/priceUtilities';
import styles from './BrowseResultService.module.css';

interface Props {
  dataOfferId: string;
  name: string;
  duration?: string;
  numGuests?: number;
  priceRangeOutput: PriceRangeOutput;
  channelOutput: ChannelOutput;
  cmsBrowsePage: CmsBrowsePage;
  pricingDisplayType: PricingDisplayType;
}

/*
  TAKE CARE - Any changes to the markup rendered by this component
  may break the Chrome score viewer extension.
  https://git.treatwell.net/qa/chrome-score-viewer-crx

  Be sure to test the extension if making any such changes to
  this component.
 */
export class BrowseResultService extends PureComponent<Props> {
  public render(): ReactNode {
    const {
      dataOfferId,
      name,
      duration,
      numGuests,
      priceRangeOutput,
      channelOutput,
      cmsBrowsePage,
      pricingDisplayType,
    } = this.props;

    const servicePriceRangeCms =
      cmsBrowsePageToServicePriceRangeCms(cmsBrowsePage);

    return (
      <div className={styles.container} data-offer-id={dataOfferId}>
        <Inline justify="between" space="md">
          <Stack>
            <Text className={styles.name}>{name}</Text>
            {duration !== undefined && (
              <Text className={styles.duration}>{duration}</Text>
            )}
            {numGuests !== undefined && (
              <GuestsIndicator numGuests={numGuests} />
            )}
          </Stack>
          <PriceDisplay
            priceRangeOutput={priceRangeOutput}
            channelOutput={channelOutput}
            servicePriceRangeCms={servicePriceRangeCms}
            pricingDisplayType={pricingDisplayType}
          />
        </Inline>
      </div>
    );
  }
}
